import * as React from "react"
import { MinMax } from "global"
let styles = require("./styles.module.scss")

export type TeslaRangeProps = MinMax & {
  className: string
  value: number
  step: number
  tip?: string
  updateFn: (value: string) => void
  formatFn?: (value: number) => string
}

export default class TeslaRange extends React.Component<TeslaRangeProps> {
  relativePosition: number

  input: HTMLElement
  indicator: HTMLElement
  wrapper: HTMLElement

  constructor(props) {
    super(props)
    this.relativePosition =
      ((this.props.value - this.props.min) * 100) /
      (this.props.max - this.props.min)
  }

  getIndicatorPosition(relativePosition) {
    if (!this.input || !this.indicator || !this.wrapper) {
      return 0
    }
    const parentElement = this.input.parentNode as HTMLElement
    const thumbSize = parentElement.getBoundingClientRect().height
    const trackSize = this.input.getBoundingClientRect().width - thumbSize
    const trackCovered = (trackSize / 100) * relativePosition
    const roofSizeOutputUnit = trackCovered + thumbSize * 0.5
    return roofSizeOutputUnit
  }

  componentDidMount() {
    const firstElementChild = this.indicator.firstElementChild as HTMLElement
    firstElementChild.style.transform = `translateX(${this.getIndicatorPosition(
      this.relativePosition
    )}px)`
  }

  render() {
    const {
      value,
      min,
      max,
      updateFn,
      formatFn,
      step = "any",
      tip = "sq ft",
    } = this.props
    const relativePosition = ((value - min) * 100) / (max - min)
    const rangeLabelClass = tip === "sq ft" ? styles.outputLabelFeet : ""

    return (
      <div
        className={styles.wrapper}
        ref={(element) => {
          this.wrapper = element
        }}
      >
        <div
          className={styles.tooltip}
          ref={(element) => {
            this.indicator = element
          }}
        >
          <div
            className={styles.output}
            style={{
              transform: `translateX(${this.getIndicatorPosition(
                relativePosition
              )}px)`,
            }}
          >
            <div>
              <span>{formatFn ? formatFn(value) : value}</span>
              <span className={styles.rangeLabelClass}>{tip}</span>
            </div>
          </div>
        </div>
        <input
          className={styles.input}
          ref={(element) => {
            this.input = element
          }}
          type="range"
          value={value}
          min={min}
          max={max}
          style={{
            backgroundImage: `linear-gradient(90deg, #7A7C93 ${relativePosition}%, #f5f5f7 ${relativePosition}%)`,
          }}
          onChange={(e) => updateFn(e.target.value)}
          step={step}
        />
      </div>
    )
  }
}
